import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import { AmplifyAuthCognitoConfig } from './AmplifyAuthCognitoConfig';

import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import datadogInit from './datadog';

Amplify.configure(AmplifyAuthCognitoConfig);

datadogInit();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({}));
